import { getRequest } from './api';

const adminApi = {
  async getAllUsers() {
    const response = await getRequest('/admin/users');
    return response;
  }
};

export default adminApi;
